import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { SessionService } from '../../../services/session.service';
import { IomCreateproposal, UserDetails } from '../../../models/iom-createproposal';
import { Router, ActivatedRoute } from '@angular/router';
import { IomService } from 'src/app/services/iom.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'src/app/services/message.service';
declare var $: any;
import { TreeModel, TreeController, TreeComponent, Ng2TreeSettings } from 'ng2-tree';
import { ScopeSelectorService } from 'src/app/services/ScopeSelectorService';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConfigService } from 'src/app/services/app-config.service';
import { MsalService } from '@azure/msal-angular';
declare var bootbox: any;
declare var userNotification: any;


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  LoggedInUser: string;
  ProposalDetailList: IomCreateproposal[];
  selectedProposalData: IomCreateproposal;
  public Client: string;
  public Engagement: string;
  public Project: string;
  proposal: { IsAuthorized: number, Market: { MarketName: string, MarketId: number }[], MarketUnit: { MarketUnitId: number, MarketUnitName: string }[], ClientGroup: { ClientGroupId: number, ClientGroupName: string }[], ProposalDetail: IomCreateproposal[] };
  ClientListFiltered: String[];
  ProjectListFiltered: String[];
  ProposalListFiltered: IomCreateproposal[];
  selectedClient: String;
  selectedProject: String;
  selectedOpportunity: String;
  mySPCustomer: String;
  mySPOpportunity: String;
  mySPSolution: String;
  proposalId: any;
  displayClient: String;
  displayProject: String;
  displayOpportunity: String;
  loadScopeSelector: boolean;
  scopeMySP: boolean;
  /* *** FDS Scope Valiable  ***** */
  scopeNodeController: TreeController;
  @ViewChild('treeComponent', { static: false }) treeComponent: TreeComponent;
  tree: TreeModel;
  treecopy: TreeModel;
  treecopyforSearch: TreeModel;
  treeSettings: Ng2TreeSettings = {
    rootIsVisible: false,
  };
  treeSettingsFDS: Ng2TreeSettings = {
    rootIsVisible: true,
  };
  previousSelectedNodeId: string;
  clients: any = [];
  urlE2EUId: any;
  urlCMSUID: any;
  urlWSUID: any;
  urlSolutionId: any;
  dsSelected: boolean;
  selectedClientUId: string;
  selectedDeliveryConstructUId: string = this.sessionService.getDeliveryConstructUId();
  selectedParentDeliveryConstructUId: string;
  userdetailsbyversionid: UserDetails;
  selectedClientName: string;
  selectedDCName: string;
  selectedParentDCName: string;
  selectedDCType: string;
  selectedParentDCType: string;
  ParentE2EUID: string;
  loadFDSScope: boolean = false;
  urlVersionId: string;
  @ViewChild('scopeSelectorId') scopeSelectorId: ElementRef;
  @ViewChild('fdsScopeSelectorId') fdsScopeSelectorId: ElementRef;
  accessDeniedMessageShow: boolean = false;
  errorOccured: boolean = false;
  proposalIdbyVersionId: string;
  bookmarkversionId: string;
  public envVar: any = null;
  PAMClient: any;
  selectedPAMClientUId: any;
  OverAllDeliveryStructure: any;
  flagforStandalone: boolean = false;
  disclaimer: boolean;
  //urlDeliveryConstructUId: any
  /* *** /FDS Scope Valiable  ***** */

  constructor(public sessionService: SessionService, private messageService: MessageService
    , public iomservice: IomService, private router: Router, private route: ActivatedRoute,
    private scopeSelectorService: ScopeSelectorService, private spinner: NgxSpinnerService, private appConfigService: AppConfigService, private msalService: MsalService) {
    this.envVar = this.appConfigService.getEnvironment();
  }
  ngOnInit() {
    window.addEventListener('ModalClosed', () => {
      this.downloadUserManul();
    })
    this.sessionService.setSessionStorageItem("Scroll", "1");
    this.messageService.subj.subscribe(data => {
      if (this.sessionService.getSessionStorageItem('userType') == "1") {
        if (!this.sessionService.getSessionStorageItem('selectedProposalId')) {
          this.proposalId = data; this.GetProposalDataById(this.proposalId)
        }
        else {
          this.proposalId = this.sessionService.getSessionStorageItem('selectedProposalId')
          this.GetProposalDataById(this.proposalId)
        }
      }
      else {
        this.sessionService.setE2EUId(data);
        this.loadFDSScope = true;
        $('#standScope').hide();
        //nneddd to handle
        if (sessionStorage.getItem("redirecttoStandalone") != "standalone") {
          $('#standaloneScope').hide();
          this.flagforStandalone = false;
          this.getClientDeliveryConstructName("default");
        }
        else {
          $('#standaloneScope').show();
          this.iomservice.IsAuthorized = false;
          this.loadFDSScope = false;
          this.flagforStandalone = true;
        }
      }
    });
    
    if (this.envVar.instanceType == 'FDS') {
      this.iomservice.isManualUpload = true;
      this.flagforStandalone = true;
      if (sessionStorage.getItem("redirecttoStandalone") != "standalone") {
        if (sessionStorage.getItem("Instance") == "PAM") {
          this.iomservice.isManualUpload = false;
          this.flagforStandalone = false;
          this.GetProData(null);
        }
        else {
          this.iomservice.isManualUpload = true;
          this.flagforStandalone = true;
          this.loadFDS();
        }
      }
      else {
        this.LoggedInUser = sessionStorage.getItem('userName');
        if (this.sessionService.getE2EDeliveryConstructName() != "" && this.sessionService.getE2EDeliveryConstructName() != null)
          this.sessionService.setDeliveryConstructName(this.sessionService.getE2EDeliveryConstructName());
        $('#standScope').hide();
        $('#standaloneScope').show();
        this.iomservice.IsAuthorized = false;
        this.loadFDSScope = false;
        this.flagforStandalone = true;
        this.iomservice.setScopeStatus('Loaded');
      }
    }
    else {
      $('#standScope').hide();
      $('#standaloneScope').hide();
      if (this.iomservice.isPAMAccess() == true) {
        this.iomservice.isManualUpload = false;
        this.loadPAM();
      }
      else {
        this.LoggedInUser = sessionStorage.getItem('userName');
        this.iomservice.setScopeStatus('Loaded');
        setTimeout(() => {
          this.router.navigate(['accessdenied']);
        }, 1000);
      }
    }
    if(this.envVar.Env == "FDS_ManualUpload"){
      this.LoggedInUser = sessionStorage.getItem('userName');
      if(sessionStorage.getItem('VersionIdMongo') == null || sessionStorage.getItem('VersionIdMongo') == undefined || sessionStorage.getItem('VersionIdMongo') == ""){
        this.bookmarkversionId = sessionStorage.getItem('VersionId');
      }
      else{
        this.bookmarkversionId = sessionStorage.getItem('VersionIdMongo')
      }
      if (this.bookmarkversionId != undefined && this.bookmarkversionId != "") {
        this.getuserdetailbyversion(this.bookmarkversionId);
      }
    else {
      this.route.queryParams.subscribe(params => {
        if (Object.keys(params).length > 0 === window.location.href.includes('?')) {
          this.urlE2EUId = this.iomservice.GetValueFromQueryParams(params, "e2euid");
          this.urlCMSUID = this.iomservice.GetValueFromQueryParams(params, "cmsuid");
          this.urlWSUID = this.iomservice.GetValueFromQueryParams(params, "wsuid");
          this.urlSolutionId = this.iomservice.GetValueFromQueryParams(params, "SolutionId")
          this.urlVersionId = this.iomservice.GetValueFromQueryParams(params, "VersionId")
        }
        if ((this.urlE2EUId != undefined && this.urlE2EUId != "") || (this.sessionService.getE2EUId() != undefined && this.sessionService.getE2EUId() != null)) {
          if (this.sessionService.getE2EUId() == undefined && this.sessionService.getE2EUId() == null)
            this.sessionService.setE2EUId(this.urlE2EUId);
          if (this.urlCMSUID != undefined && this.urlCMSUID != "")
            this.sessionService.setCMSUId(this.urlCMSUID);
          if (this.urlWSUID != undefined && this.urlWSUID != "")
            this.sessionService.setWSUId(this.urlWSUID);
          if (!this.loadFDSScope) {
            this.loadFDSScope = true;
            $('#standScope').hide();
            this.sessionService.setSessionStorageItem("userType", "3");
            this.getClientDeliveryConstructName("default");
          }
        }
        else if ((this.urlSolutionId != undefined && this.urlSolutionId != "") || (this.sessionService.getSolutionId() != undefined && this.sessionService.getSolutionId() != null)) {
          this.sessionService.setSessionStorageItem("userType", "4");
          if (this.sessionService.getSolutionId() == undefined && this.sessionService.getSolutionId() == null)
            this.sessionService.setSolutionId(this.urlSolutionId);
          this.getMySPClientDetails(this.sessionService.getSolutionId());
        }
        else {
          this.sessionService.setSessionStorageItem("userType", "1");
          if (!this.sessionService.getSessionStorageItem('selectedProposalId')) {
            this.GetProposalDataById(0);
          }
          else {
            this.proposalId = this.sessionService.getSessionStorageItem('selectedProposalId')
            this.GetProposalDataById(this.proposalId)
          }
        }
        setTimeout(() => {
          document.body.click();
        }, 8000);
      }, (error: any) => {
        this.spinner.hide();
        // this.errorOccured = true;
        this.iomservice.setScopeStatus('Loaded');
        this.router.navigate(['error']);
      });
    }
    }
    let that = this;
    $(document).ready(function () {
      $(".myw-scope .dropdown-menu").click(function (e) {
        e.stopPropagation();
      });
    });
    window.addEventListener('load', function () {
      setTimeout(() => {
        $('#loadScope').trigger('click');
        that.spinner.hide();
      }, 1000);
    })
  }
  GetProData(UserType : any) {
    this.spinner.show();
    this.iomservice.getProp<any>(this.sessionService.getUserName(), "").subscribe(data => {
      this.spinner.hide();
      var proposal = data.ProposalDetail.filter(x => x.ProposalId == this.sessionService.getE2EUId())[0];
      if (proposal != null && proposal.IsDecommRequest==0) {
        this.sessionService.setDeliveryConstructUId(proposal.ProposalId);
        this.sessionService.setSessionStorageItem("clientName", proposal.ClientName);
        this.sessionService.setDeliveryConstructName(proposal.ProposalName);
        this.LoggedInUser = sessionStorage.getItem('userName');
        if(UserType!=null && UserType!=undefined && UserType =='1')
        {
          sessionStorage.setItem("Instance", 'PAM');
          this.sessionService.setSessionStorageItem("userType", "1");
        }
        else if (this.envVar.Env == "SAAS_ManualUpload") {             
          if(sessionStorage.getItem("Instance") == "SAAS"){
            this.sessionService.setSessionStorageItem("userType", "3");  
            sessionStorage.setItem("redirecttoStandalone", "standalone");
            sessionStorage.setItem("Instance", 'SAAS');
          }  
          else if (sessionStorage.getItem("Instance") == "PAM") {
            this.sessionService.setSessionStorageItem("userType", "1");
            sessionStorage.setItem("Instance", 'PAM');
          }                          
        }
        else{
        this.sessionService.setSessionStorageItem("userType", "3");
        sessionStorage.setItem("redirecttoStandalone", "standalone");
        }
        $('#standScope').hide();
        $('#standaloneScope').show();
        this.iomservice.IsAuthorized = false;
        this.loadFDSScope = false;
        this.flagforStandalone = true;
        this.iomservice.setScopeStatus('Loaded');
      }
      else if(proposal == undefined  || proposal.IsDecommRequest==1){
        this.iomservice.IsAuthorized = false;
        //this.accessDeniedMessageShow = true;
        this.iomservice.setScopeStatus('Loaded');
        this.router.navigate(['accessdenied']);
      }
      else {
        $('#standScope').hide();
        $('#standaloneScope').hide();
        this.loadFDSScope = false;
        bootbox.alert("Application is not provisioned!");
      }
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        console.log("Error Occured !");
      });
  }
  loadPAM() {
    this.LoggedInUser = sessionStorage.getItem('userName');
    this.bookmarkversionId = sessionStorage.getItem('VersionId');
    if (this.bookmarkversionId != undefined && this.bookmarkversionId != "") {
      this.getuserdetailbyversion(this.bookmarkversionId);
    }
    else {
      this.route.queryParams.subscribe(params => {
        if (Object.keys(params).length > 0 === window.location.href.includes('?')) {
          this.urlE2EUId = this.iomservice.GetValueFromQueryParams(params, "ClientUId");
          this.urlCMSUID = this.iomservice.GetValueFromQueryParams(params, "AssociatedDeliveryConstructUId");
          this.urlWSUID = this.iomservice.GetValueFromQueryParams(params, "DeliveryConstructUId");
          if (this.urlE2EUId != undefined && this.urlE2EUId != "")
            this.sessionService.setE2EUId(this.urlE2EUId);
          if (this.urlCMSUID != undefined && this.urlCMSUID != "")
            this.sessionService.setCMSUId(this.urlCMSUID);
          if (this.urlWSUID != undefined && this.urlWSUID != "")
            this.sessionService.setWSUId(this.urlWSUID);

          if ((this.urlE2EUId == undefined || this.urlE2EUId == "") && this.sessionService.getE2EUId() != null)
            this.urlE2EUId = this.sessionService.getE2EUId();

          if ((this.urlCMSUID == undefined || this.urlCMSUID == "") && this.sessionService.getCMSUId() != null)
            this.urlCMSUID = this.sessionService.getCMSUId()

          if ((this.urlWSUID == undefined || this.urlWSUID == "") && this.sessionService.getWSUId() != null)
            this.urlWSUID = this.sessionService.getWSUId()
        }
        if ((this.urlE2EUId != undefined && this.urlE2EUId != "") || (this.sessionService.getE2EUId() != undefined && this.sessionService.getE2EUId() != null)) {
          if (!this.loadFDSScope) {
            this.loadFDSScope = this.checkForScope();
            $('#standScope').hide();
            this.sessionService.setSessionStorageItem("userType", "3");
            this.getClientDeliveryConstructName("default");
          }
        }
        else {
          if (!this.loadFDSScope) {
            this.loadFDSScope = this.checkForScope();
            $('#standScope').hide();
            this.sessionService.setSessionStorageItem("userType", "3");
            this.sessionService.setE2EUId("00050000-0000-0000-0000-000000000000");
            this.urlE2EUId = "00050000-0000-0000-0000-000000000000";
            this.urlWSUID = "00050000-0000-0000-0000-000000000000";
            this.sessionService.setWSUId("00050000-0000-0000-0000-000000000000");
            this.getClientDeliveryConstructName("default");
          }
        }
        setTimeout(() => {
          document.body.click();
        }, 4000);
      }, (error: any) => {
        this.spinner.hide();
        // this.errorOccured = true;
        this.iomservice.setScopeStatus('Loaded');
        this.router.navigate(['error']);
      });
    }
  }
  loadFDS() {
    this.LoggedInUser = sessionStorage.getItem('userName');
    this.bookmarkversionId = sessionStorage.getItem('VersionId');
    this.route.queryParams.subscribe(params => {
      if (Object.keys(params).length > 0 === window.location.href.includes('?')) {
        this.urlE2EUId = this.iomservice.GetValueFromQueryParams(params, "e2euid");
        this.urlCMSUID = this.iomservice.GetValueFromQueryParams(params, "cmsuid");
        this.urlWSUID = this.iomservice.GetValueFromQueryParams(params, "wsuid");
        this.urlSolutionId = this.iomservice.GetValueFromQueryParams(params, "SolutionId")
        this.urlVersionId = this.iomservice.GetValueFromQueryParams(params, "VersionId")
      }
      if (this.bookmarkversionId != undefined && this.bookmarkversionId != "") {
        if(this.sessionService.getSessionStorageItem('selectedProposalId') == null)
        {
          this.getuserdetailbyversion(this.bookmarkversionId);
        }
      }
      else {
        if ((this.urlE2EUId != undefined && this.urlE2EUId != "") || (this.sessionService.getE2EUId() != undefined && this.sessionService.getE2EUId() != null)) {
          if (this.sessionService.getE2EUId() == undefined && this.sessionService.getE2EUId() == null)
            this.sessionService.setE2EUId(this.urlE2EUId);
          if (this.urlCMSUID != undefined && this.urlCMSUID != "")
            this.sessionService.setCMSUId(this.urlCMSUID);
          if (this.urlWSUID != undefined && this.urlWSUID != "")
            this.sessionService.setWSUId(this.urlWSUID);
          if (!this.loadFDSScope) {
            this.loadFDSScope = this.checkForScope();
            $('#standScope').hide();
            this.sessionService.setSessionStorageItem("userType", "3");
            //need to handle
            if (sessionStorage.getItem("redirecttoStandalone") != "standalone") {
              this.flagforStandalone = false;
              this.getClientDeliveryConstructName("default");
            }
            else {
              this.iomservice.IsAuthorized = false;
              this.loadFDSScope = false;
              this.flagforStandalone = true;
            }
          }
        }
        else if ((this.urlSolutionId != undefined && this.urlSolutionId != "") || (this.sessionService.getSolutionId() != undefined && this.sessionService.getSolutionId() != null)) {
          this.sessionService.setSessionStorageItem("userType", "4");
          if (this.sessionService.getSolutionId() == undefined && this.sessionService.getSolutionId() == null)
            this.sessionService.setSolutionId(this.urlSolutionId);
          this.getMySPClientDetails(this.sessionService.getSolutionId());
        }
        else {
          if (this.envVar.instanceType == "FDS") {
            $('#standScope').hide();
            var userType = parseInt(this.sessionService.getSessionStorageItem('userType'));
            if(userType == null || userType == undefined){
              this.sessionService.setSessionStorageItem("userType", "3");
            }
            //this.iomservice.IsAuthorized = false;
            this.iomservice.setScopeStatus('Loaded');
          }
          else {
            this.sessionService.setSessionStorageItem("userType", "1");
            if (!this.sessionService.getSessionStorageItem('selectedProposalId')) {
              this.GetProposalDataById(0);
            }
            else {
              this.proposalId = this.sessionService.getSessionStorageItem('selectedProposalId')
              this.GetProposalDataById(this.proposalId)
            }
          }
        }
      }
      setTimeout(() => {
        document.body.click();
      }, 8000);
    }, (error: any) => {
      this.spinner.hide();
      // this.errorOccured = true;
      this.iomservice.setScopeStatus('Loaded');
      this.router.navigate(['error']);
    });
  }
  getEngagement(event: any) {
    // if(this.selectedClient=="Select"){
    //   bootbox.alert("Please select Client");
    // }
    //this.Client = event.target.options[event.target.selectedIndex].text;    
    let queriedData = this.ProposalDetailList.filter(x => x.ClientName == this.selectedClient);
    this.ProjectListFiltered = [...new Set(queriedData.map(x => x.ProjectName))];
    this.ProposalListFiltered = this.ProposalDetailList.filter(x => x.ClientName == this.selectedClient).filter(x => x.ProjectName == this.selectedProject);
    if (this.ProjectListFiltered.length > 0) {
      if (!this.selectedProject) {
        this.selectedProject = this.ProjectListFiltered[0];
      }
      else if (!(this.ProjectListFiltered.indexOf(this.selectedProject) > -1)) {
        this.selectedProject = this.ProjectListFiltered[0];
      }
      this.getProject(null);
    }
    else{
      this.selectedProject = "Select";
      this.selectedOpportunity = "Select";
    }
    // this.getProject(null);
  }

  getProject(event: any) {
    //this.Project = event.target.options[event.target.selecatedIndex].text;
    this.ProposalListFiltered = this.ProposalDetailList.filter(x => x.ClientName == this.selectedClient).filter(x => x.ProjectName == this.selectedProject);
    // this.ProposalListFiltered = this.ProposalDetailList.filter(x => x.ProjectName == this.selectedProject);
    if (this.ProposalListFiltered.length > 0) {
      if (!this.selectedOpportunity) {
        this.selectedOpportunity = this.ProposalListFiltered[0].ProposalName;
      }
      else if (!(this.ProposalListFiltered.map(x => x.ProposalName).indexOf(this.selectedOpportunity) > -1)) {
        this.selectedOpportunity = this.ProposalListFiltered[0].ProposalName;
      }
      // else if(this.ProposalListFiltered[0]!=null) {
      //   this.selectedOpportunity = this.ProposalListFiltered[0].ProposalName;
      // }
      this.getProposal(null);
    }
  }
  getProposal(event: any) {
    let queriedData = this.ProposalDetailList.filter(x => x.ClientName == this.selectedClient).filter(x => x.ProjectName == this.selectedProject).find(x => x.ProposalName == this.selectedOpportunity);
    // let queriedData = this.ProposalDetailList.find(x => x.ProposalName == this.selectedOpportunity);
    this.proposalId = queriedData.ProposalId;
  }
  //ByProposalId 
  GetProposalDataById(selectedProposalId: any) {
    this.spinner.show();
    //console.log('Prosal api called');
    this.displayClient = "";
    this.displayProject = "";
    this.displayOpportunity = "";
    this.iomservice.getProp<any>(this.sessionService.getUserName(), "").subscribe(data => {
      if (!window.location.href.toLowerCase().includes('versionid')) {
        this.spinner.hide();
      }
      this.sessionService.setSessionStorageItem("ProposalData", JSON.stringify(data));
      this.proposal = data;
      if(this.envVar.Env == "SAAS_ManualUpload" && this.proposal.ProposalDetail.length > 0){
        this.proposal.IsAuthorized = 1;
      }
      if (this.proposal.IsAuthorized === 1) {
        this.iomservice.IsAuthorized = true;
        if (this.proposal.ProposalDetail && this.proposal.ProposalDetail.length > 0) {
          if (!selectedProposalId) {
            selectedProposalId = this.proposal.ProposalDetail[0].ProposalId;
            this.sessionService.setSessionStorageItem("selectedProposalId", (selectedProposalId).toString());
          }
          this.ProposalDetailList = this.proposal.ProposalDetail;
          this.selectedProposalData = this.proposal.ProposalDetail.find(x => x.ProposalId == selectedProposalId);
          this.ClientListFiltered = [...new Set(this.ProposalDetailList.map(x => x.ClientName))];
          if (this.selectedProposalData) {
            this.selectedClient = this.selectedProposalData.ClientName;
            this.selectedProject = this.selectedProposalData.ProjectName;
            this.selectedOpportunity = this.selectedProposalData.ProposalName;
            this.getEngagement(null);
            this.displayClient = this.selectedClient;
            this.displayProject = this.selectedProject;
            this.displayOpportunity = this.selectedOpportunity;
            this.hideScopeSelector(); // hide/show scope      
          }
          else {
            this.iomservice.IsAuthorized = false;
            //this.accessDeniedMessageShow = true;
            this.iomservice.setScopeStatus('Loaded');
            this.router.navigate(['accessdenied']);
          }
        }
        this.iomservice.setScopeStatus("Loaded"); // LOad when standalone component is loaded.
      }
      else if (this.proposal.IsAuthorized === 2) {
        this.iomservice.setScopeStatus('Loaded');
        this.router.navigate(['error']);
      }
      else {
        this.iomservice.IsAuthorized = false;
        //this.accessDeniedMessageShow = true;
        this.iomservice.setScopeStatus('Loaded');
        this.router.navigate(['accessdenied']);
      }
      // this.router.navigate(['proposalsummary']);
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
        this.iomservice.setScopeStatus('Loaded');
        this.router.navigate(['error']);
      });
  }
  // ngDoCheck() {
  //   if (this.iomservice.ScopeCheckCounter == undefined || this.iomservice.ScopeCheckCounter < 100) {
  //     $('#loadScope').trigger('click');
  //     this.iomservice.ScopeCheckCounter = this.iomservice.ScopeCheckCounter + 1;
  //   }
  // }
  validate(): boolean{
    if(this.selectedClient=="Select"){
      bootbox.alert("Please select Client");
      return false;
    }
    else if(this.selectedProject == "Select"){
      bootbox.alert("Please select Project");
      return false;
    }
    else if(this.selectedOpportunity == "Select"){
      bootbox.alert("Please select Opportunity");
      return false;
    }
    else{
      return true;
    }
  }
  passOppId(event) {
    $('#scopeSelector').removeClass("myw-header-item dropdown-toggle show");
    $('#scopeSelector').addClass("myw-header-item dropdown-toggle");
    if(this.validate()){
    this.sessionService.setSessionStorageItem("selectedProposalId", (this.proposalId).toString());
    this.sessionService.setDeliveryConstructUId((this.proposalId).toString());  
    this.messageService.loadHeader(this.proposalId);
    this.scopeSelectorId.nativeElement.classList.remove('show');
    if (this.router.url == "/deepdive") {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['deepdive'])); 
    }
    else {
      this.router.navigate(['deepdive']);
    }
  }
}

  // updateOpportunity(event: any) {
  //   this.Client = event.target.options[event.target.selectedIndex].text;
  //   this.marketUnitListFiltered = this.marketUnitList.filter(x=> x.ClientID= this.ClientId);
  // }

  hideScopeSelector() {
    let url = window.location.href;
    if (url.includes('/proposalsummary') || url.includes('/createproposal') || url.includes('/editproposal') || url.includes('/accessdenied') || url.includes('/error') || url.includes('/logout')) {
      this.loadScopeSelector = false;
      $('#standScope').hide();
      //this.iomservice.setScopeStatus('Loaded');
    } else {
      $('#standScope').show();
      this.loadScopeSelector = true;
    }
  }
  checkForScope() {
    let url = window.location.href;
    if (url.includes('/proposalsummary') || url.includes('/createproposal') || url.includes('/editproposal') || url.includes('/accessdenied') || url.includes('/error') || url.includes('/logout')) {
      $('#standScope').hide();
      return false;
    }
    else
      return true;
  }
  hideTopBar() {
    if (this.router.url.startsWith('/landing')) {
      return true;
    } else {
      return false;
    }
  }
  hideScopeSelectorinLogout() {
    if (this.router.url.startsWith('/logout') || this.router.url.startsWith('/accessdenied') || this.router.url.startsWith('/error')) {
      $('#standScope').hide();
      return true;
    } else {
      return false;
    }
  }


  getClientsInfo() {
    this.scopeSelectorService.getAllClients()
      .subscribe((res: any) => {
        this.clients = JSON.parse(JSON.stringify(res));
        var clientUId = this.sessionService.getClientUId();
        var clientName = this.clients.filter(function (item) {
          return item.ClientUId == clientUId;
        });
        var E2EUId = this.sessionService.getE2EUId();
        if (this.urlE2EUId == "00000000-0000-0000-0000-000000000000") {
          if (E2EUId == "00000000-0000-0000-0000-000000000000") {
            this.sessionService.setE2EUId(E2EUId);
          }
        }
        else {
          this.sessionService.setE2EUId(this.urlE2EUId);
        }
        this.getClientDeliveryConstructName(clientName[0].Name);
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {
            clientUId: this.sessionService.getClientUId(),
            deliveryConstructUId: this.sessionService.getE2EUId()
          },
          queryParamsHandling: 'merge',
          skipLocationChange: true,
          replaceUrl: true
        });
        const params = this.router.url.split('?')[1]
        if (params) {
          window.history.replaceState({}, '', `${location.pathname}?${params}`)
        }
      }, (error: any) => {
        //console.log(error)
        // this.errorOccured = true;
        this.iomservice.setScopeStatus('Loaded');
        this.router.navigate(['error']);
      });
  }
  //Fetches MYSP client details with access
  getMySPClientDetails(solutionId) {
    if (this.sessionService.getSolutionId() !== undefined &&
      this.sessionService.getSolutionId() !== 'null') {
      this.iomservice.getMySPClientDetails(solutionId,
        this.LoggedInUser)
        .subscribe((clientDetails: any) => {
          this.spinner.hide();
          // console.log(clientDetails);
          if (clientDetails != null && clientDetails.hasAccess == true) {
            this.displayClient = clientDetails.Client;
            this.displayProject = clientDetails.EngagementName;
            this.displayOpportunity = clientDetails.SolutionName;
            this.scopeMySP = true;
            this.mySPCustomer = clientDetails.Client;
            this.mySPOpportunity = clientDetails.EngagementName;
            this.mySPSolution = clientDetails.SolutionName;
            this.iomservice.setScopeStatus("Loaded"); // load component post scope loaded
          }
          else {
            // this.accessDeniedMessageShow = true;
            this.iomservice.setScopeStatus('Loaded');
            this.router.navigate(['accessdenied']);
          }
          this.loadScopeSelector = true;
        }), (error: any) => {
          this.spinner.hide();
          // this.errorOccured = true;
          this.iomservice.setScopeStatus('Loaded');
          this.router.navigate(['error']);
        };
    }

  }
  getClientDeliveryConstructName(clientName) {
    $('#standScope').hide();
    var clientUId = this.sessionService.getClientUId();
    if (this.sessionService.getE2EUId() !== undefined &&
      this.sessionService.getE2EUId() !== 'null' && this.envVar.Env != "SAAS_ManualUpload") {
      this.spinner.show();
      this.scopeSelectorService.getDeliveryConstructbyId(clientUId,
        this.sessionService.getE2EUId())
        .subscribe((dcRes: any) => {
          this.spinner.hide();
          if(this.sessionService.getWSUId()!=null){
            this.sessionService.setDeliveryConstructUId(this.sessionService.getWSUId());
          }
          else{
          this.sessionService.setDeliveryConstructUId(this.sessionService.getE2EUId());
          } // for testing as scope data is not configure     
          if (dcRes) {
            if (dcRes.IsAuthorized === 1) {
              if (this.envVar.instanceType == 'FDS') {
                //this.iomservice.readonlyDD = dcRes.ReadOnlyDD;
                //this.iomservice.demoe2euid = dcRes.DemoE2EUID;
                this.iomservice.readonlyDD = false;
                this.iomservice.demoe2euid = false;
                this.iomservice.IsAuthorized = true;
                // if(dcRes.ScopeSelectorDataFds.DeliveryConstruct != null)
                // this.iomservice.redirecttoStandalone = false;
                //if (this.envVar.instanceType != 'FDS')
                //dcRes.ScopeSelectorDataFds.ClientName
                if (dcRes.ClientName != null && dcRes.ClientName != '' && dcRes.ClientName != undefined) {
                  this.sessionService.setClientName(dcRes.ClientName);
                }
                else {
                  this.sessionService.setClientName(dcRes.ScopeSelectorDataFds.ClientName);
                  //this.flagforStandalone = true;
                  sessionStorage.setItem("redirecttoStandalone", "standalone");
                  $('#standScope').hide();
                  $('#standaloneScope').show();
                  this.iomservice.IsAuthorized = false;
                  this.loadFDSScope = false;
                  this.flagforStandalone = true;
                  this.iomservice.setScopeStatus('Loaded');
                }
                if(this.envVar.Env == "FDS_ManualUpload" && this.sessionService.getSessionStorageItem('userType') == "3"){
                if(this.flagforStandalone && this.loadFDSScope == false ) // if condtion added to load standalonescope selector not tree
                this.sessionService.setDeliveryConstructName(dcRes.ScopeSelectorData.DeliveryConstruct);
                else
                this.sessionService.setE2EDeliveryConstructName(dcRes.ScopeSelectorData.DeliveryConstruct);
                // this.sessionService.setClientUId(this.selectedClientUId);
                if (dcRes.ScopeSelectorData.DeliveryConstructUId != null)
                  this.sessionService.setDeliveryConstructUId(dcRes.ScopeSelectorData.DeliveryConstructUId)
                }
                else{
                  if(this.flagforStandalone && this.loadFDSScope == false ) // if condtion added to load standalonescope selector not tree
                this.sessionService.setDeliveryConstructName(dcRes.ScopeSelectorDataFds.DeliveryConstruct);
                else
                this.sessionService.setE2EDeliveryConstructName(dcRes.ScopeSelectorDataFds.DeliveryConstruct);
                // this.sessionService.setClientUId(this.selectedClientUId);
                if (dcRes.ScopeSelectorDataFds.DeliveryConstructUId != null)
                  this.sessionService.setDeliveryConstructUId(dcRes.ScopeSelectorDataFds.DeliveryConstructUId)
                }
                // if(this.sessionService.getWSUId()!=null){
                //   this.sessionService.setDeliveryConstructUId(this.sessionService.getWSUId());
                // }
                this.loadDeliveryConstructTree(this.sessionService.getE2EUId(), this.sessionService.getDeliveryConstructUId());
              }
              else {
                this.iomservice.readonlyDD = false;
                this.iomservice.demoe2euid = false;
                this.iomservice.IsAuthorized = true;
                this.PAMClient = dcRes.ScopeSelectorData.Children;
                this.OverAllDeliveryStructure = dcRes.DeliveryStructure;
                if (this.sessionService.getE2EUId() != "00050000-0000-0000-0000-000000000000") {
                  this.selectedPAMClientUId = this.urlE2EUId;
                  if (this.envVar.instanceType != 'FDS')
                    this.sessionService.setClientName(dcRes.ScopeSelectorData.DeliveryConstruct);
                  this.loadPAMTree(this.selectedPAMClientUId);
                } else {
                  //this.sessionService.setE2EDeliveryConstructName(dcRes.ScopeSelectorData.Children[0].DeliveryConstruct);
                  //this.sessionService.setE2EUId(dcRes.ScopeSelectorData.Children[0].DeliveryConstructUId);
                  //this.sessionService.setDeliveryConstructUId(dcRes.ScopeSelectorData.Children[0].DeliveryConstructUId)
                  //this.selectedPAMClientUId = dcRes.ScopeSelectorData.Children[0].DeliveryConstructUId;
                  if (this.envVar.instanceType != 'FDS')
                    this.sessionService.setClientName(dcRes.ScopeSelectorData.DeliveryConstruct);

                  this.sessionService.setDeliveryConstructUId(this.urlWSUID);
                  this.selectedPAMClientUId = this.urlE2EUId;
                  this.loadDefaultPAMTree(this.selectedPAMClientUId, true);
                }
              }
            }
            else if (dcRes.IsAuthorized === 2) {
              this.spinner.hide();
              this.clearScopeSelection();
              this.iomservice.setScopeStatus('Loaded');
              this.router.navigate(['error']);
            }
            else {
              this.spinner.hide();
              this.clearScopeSelection();
              this.iomservice.IsAuthorized = false;
              // this.accessDeniedMessageShow = true;
              this.iomservice.setScopeStatus('Loaded');
              this.router.navigate(['accessdenied']);
            }
          }
          setTimeout(() => {
            document.body.click();
          }, 6000);
        }, (error: any) => {
          // this.errorOccured = true;
          this.spinner.hide();
          this.iomservice.setScopeStatus('Loaded');
          this.router.navigate(['error']);
          setTimeout(() => {
            document.body.click();
          }, 6000);
        });
    }
    if(this.envVar.Env == "SAAS_ManualUpload"){
      this.GetProData(null);
    }
  }
  clearScopeSelection() {
    sessionStorage.removeItem("clientName");
    sessionStorage.removeItem("e2eDeliveryConstructName");
    sessionStorage.removeItem("deliveryParentConstructName");
    sessionStorage.removeItem("deliveryConstructName");
  }
  loadDeliveryConstructTree(e2EUID, deliverystructureUID) {
    this.spinner.show();
    this.scopeSelectorService.getDeliveryConstructs(e2EUID, deliverystructureUID)
      .subscribe((res: any) => {
        if (res) {
          this.tree = res;
          this.treecopyforSearch = JSON.parse(JSON.stringify(this.tree))
          this.treecopy = JSON.parse(JSON.stringify(this.tree));
          this.iomservice.setScopeStatus("Loaded"); //Load routing post scope is loaded.
          setTimeout(() => {
            document.body.click();
          }, 6000);
        }
         this.spinner.hide();
      }, (error: any) => {
        this.spinner.hide();
        this.iomservice.setScopeStatus('Loaded');
        this.router.navigate(['error']);
        setTimeout(() => {
          document.body.click();
        }, 6000);
      });
  }
  loadDefaultPAMTree(selectedPAMClientUId: any, flag) {
    let FlData;
    if (selectedPAMClientUId == "00050000-0000-0000-0000-000000000000") {
      this.dsSelected = false;
      FlData = this.PAMClient.filter(x => x.ParentDeliveryConstructUId == selectedPAMClientUId);
      this.selectedPAMClientUId = FlData[0].DeliveryConstructUId;
      sessionStorage.removeItem("e2eDeliveryConstructName");
      sessionStorage.removeItem("deliveryParentConstructName");
      sessionStorage.removeItem("deliveryConstructName");
      sessionStorage.removeItem("cMSUID");
      this.sessionService.setE2EUId("00050000-0000-0000-0000-000000000000");
      this.urlE2EUId = "00050000-0000-0000-0000-000000000000";
      this.urlWSUID = "00050000-0000-0000-0000-000000000000";
      this.urlCMSUID = "";
      this.sessionService.setDeliveryConstructUId(this.urlWSUID);
      this.sessionService.setWSUId("00050000-0000-0000-0000-000000000000");
      this.tree = this.scopeSelectorService.getFormatedDeliveryStructureForPAM(FlData[0]);
      this.treecopyforSearch = JSON.parse(JSON.stringify(this.tree))
      this.treecopy = JSON.parse(JSON.stringify(this.tree));
      this.selectedDCType = "";
      this.iomservice.setScopeStatus("Loaded"); //Load routing post scope is loaded. 
      if (flag == false)
        if (this.router.url.includes("/deepdive")) {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.router.navigate(['deepdive'], { queryParams: { ClientUId: this.urlE2EUId, AssociatedDeliveryConstructUId: "", DeliveryConstructUId: this.urlWSUID } }));
        } else {
          this.router.navigate(['deepdive'], { queryParams: { ClientUId: this.urlE2EUId, AssociatedDeliveryConstructUId: "", DeliveryConstructUId: this.urlWSUID } });
        }
    }
    else {
      this.dsSelected = true;
      this.selectedDeliveryConstructUId = selectedPAMClientUId;
      this.ParentE2EUID = "";
      FlData = this.PAMClient.filter(x => x.DeliveryConstructUId == selectedPAMClientUId);
      this.tree = this.scopeSelectorService.getFormatedDeliveryStructureForPAM(FlData[0]);
      this.treecopyforSearch = JSON.parse(JSON.stringify(this.tree))
      this.treecopy = JSON.parse(JSON.stringify(this.tree));
      this.selectedDCType = "";
      this.iomservice.setScopeStatus("Loaded"); //Load routing post scope is loaded. 
    }
  }
  loadPAMTree(selectedPAMClientUId: any) {
    if (this.bookmarkversionId == undefined || this.bookmarkversionId == "") {
      this.route.queryParams.subscribe(params => {
        if (Object.keys(params).length > 0 === window.location.href.includes('?')) {
          this.urlE2EUId = this.iomservice.GetValueFromQueryParams(params, "ClientUId");
          this.urlCMSUID = this.iomservice.GetValueFromQueryParams(params, "AssociatedDeliveryConstructUId");
          this.urlWSUID = this.iomservice.GetValueFromQueryParams(params, "DeliveryConstructUId");
        }
      });
    }
    let e2eData = this.PAMClient.filter(x => x.DeliveryConstructUId == selectedPAMClientUId);
    this.sessionService.setE2EDeliveryConstructName(e2eData[0].DeliveryConstruct);
    this.sessionService.setDeliveryConstructUId(e2eData[0].DeliveryConstructUId)
    if ((this.urlCMSUID != "" && this.urlCMSUID != undefined) && this.urlCMSUID != this.urlE2EUId) {
      this.sessionService.setParentDeliveryConstructName(this.OverAllDeliveryStructure.find(x => x.DeliveryConstructUId == this.urlCMSUID).DeliveryConstruct);
      this.sessionService.setCMSUId(this.urlCMSUID);
    }
    if (this.urlWSUID != "" && this.urlWSUID != undefined) {
      this.sessionService.setDeliveryConstructUId(this.urlWSUID);
      this.sessionService.setWSUId(this.urlWSUID);
      if (this.urlE2EUId != this.urlWSUID) {
        this.sessionService.setDeliveryConstructName(this.OverAllDeliveryStructure.find(x => x.DeliveryConstructUId == this.urlWSUID).DeliveryConstruct);
      }
    }
    else if (this.urlE2EUId != this.urlWSUID) {
      this.sessionService.setDeliveryConstructUId(this.urlWSUID);
      this.sessionService.setWSUId(this.urlWSUID);
      this.sessionService.setDeliveryConstructName(this.OverAllDeliveryStructure.find(x => x.DeliveryConstructUId == this.urlWSUID).DeliveryConstruct);
    }

    this.tree = this.scopeSelectorService.getFormatedDeliveryStructureForPAM(e2eData[0]);
    this.treecopyforSearch = JSON.parse(JSON.stringify(this.tree))
    this.treecopy = JSON.parse(JSON.stringify(this.tree));
    this.selectedDCType = "";
    this.iomservice.setScopeStatus("Loaded"); //Load routing post scope is loaded.       
  }

  onNodeSelected(e) {
    $('#fdsScopeSelectorId').addClass(".dropdown-menu .show");
    if (this.envVar.instanceType == 'FDS') {
      this.scopeNodeController = this.treeComponent.getControllerByNodeId(e.node.id.toString());
      this.selectedClientUId = this.sessionService.getClientName();
      this.selectedClientName = this.sessionService.getClientName();
      if (e.node.node.nodeType != 'EndToEnd')
        this.selectedDCName = e.node.node.dispalyValue;
      else
        this.selectedDCName = "";

      this.selectedDeliveryConstructUId = e.node.node.id.toString();
      this.selectedDCType = e.node.node.nodeType;
      if ((e.node.parent != null || e.node.parent != undefined) && e.node.parent.node.nodeType != 'EndToEnd') {
        this.selectedParentDeliveryConstructUId = e.node.parent.node.id.toString();
        this.selectedParentDCName = e.node.parent.node.dispalyValue;
        this.selectedParentDCType = e.node.parent.node.nodeType;
      }
      else {
        this.selectedParentDeliveryConstructUId = "";
        this.selectedParentDCName = "";
        this.selectedParentDCType = "";
      }

      if (this.scopeNodeController != null && this.scopeNodeController != undefined) {
        if (this.scopeNodeController.isCollapsed()) {
          this.scopeNodeController.expand();
        } else {
          this.scopeNodeController.collapse();
        }
      }
    }
    else {
      this.scopeNodeController = this.treeComponent.getControllerByNodeId(e.node.id.toString());
      this.selectedClientUId = this.sessionService.getClientName();
      this.selectedClientName = this.sessionService.getClientName();
      if (e.node.node.nodeType != 'Client')
        this.selectedDCName = e.node.node.dispalyValue;
      else
        this.selectedDCName = "";

      this.selectedDeliveryConstructUId = e.node.node.id.toString();
      this.selectedDCType = e.node.node.nodeType;
      if ((this.selectedDCType != null || this.selectedDCType != undefined) && this.selectedDCType == 'DC') {
        this.selectedParentDeliveryConstructUId = e.node.parent.node.id.toString();
        this.selectedParentDCName = e.node.parent.node.dispalyValue;
        this.selectedParentDCType = e.node.parent.node.nodeType;
        this.ParentE2EUID = e.node.parent.node.ParentE2EUID == undefined ? '' : e.node.parent.node.ParentE2EUID;
      }
      else {
        this.selectedParentDeliveryConstructUId = "";
        this.selectedParentDCName = "";
        this.selectedParentDCType = "";
        this.ParentE2EUID = "";
      }

      if (this.scopeNodeController != null && this.scopeNodeController != undefined) {
        if (this.scopeNodeController.isCollapsed()) {
          this.scopeNodeController.expand();
        } else {
          this.scopeNodeController.collapse();
        }
      }
    }
  }
  onNodeExpanded(e) {
    if (this.previousSelectedNodeId != null && this.previousSelectedNodeId != undefined && this.previousSelectedNodeId != e.node.node.clientUId) {
      var controller = this.treeComponent.getControllerByNodeId(this.previousSelectedNodeId);
      if (controller) {
        controller.collapse();
      }
    }
    this.previousSelectedNodeId = e.node.node.clientName;
    $('#fdsScopeSelectorId').addClass("dropdown-menu show");
  }
  apply() {
    if (this.validateScopeSelector()) { //when client is selected
      this.applyActions();
      this.fdsScopeSelectorId.nativeElement.classList.remove('show');
      this.spinner.show();
    }
  }
  validateScopeSelector() {
    if (this.selectedClientUId !== null && this.selectedDeliveryConstructUId !== null && this.selectedClientUId !== 'Select Client')
      return true;
    else
      return false;
  }
  applyActions() {
    if (this.envVar.instanceType == 'FDS') {
      //this.sessionService.setClientName(this.selectedClientName);
      this.sessionService.setDeliveryConstructName(this.selectedDCName);
      this.sessionService.setParentDeliveryConstructName(this.selectedParentDCName);
      this.sessionService.setDeliveryConstructUId(this.selectedDeliveryConstructUId);
      this.sessionService.removeSessionValue("wSUId");
      this.sessionService.removeSessionValue("cMSUID");
      if (this.selectedDCType == "CMS") {
        this.sessionService.setCMSUId(this.selectedDeliveryConstructUId);
      }
      else if (this.selectedDCType == "WS") {
        this.sessionService.setWSUId(this.selectedDeliveryConstructUId);
        if (this.selectedParentDCType == "CMS") {
          this.sessionService.setCMSUId(this.selectedParentDeliveryConstructUId);
        }
      }
      else if (this.selectedDCType == "EndToEnd") {
        this.sessionService.setE2EUId(this.selectedDeliveryConstructUId);
      }
    }
    else {
      this.dsSelected = true;
      // Clear values
      this.sessionService.removeSessionValue("wSUId");
      this.sessionService.removeSessionValue("cMSUID");
      sessionStorage.removeItem("e2eDeliveryConstructName");
      sessionStorage.removeItem("deliveryParentConstructName");
      sessionStorage.removeItem("deliveryConstructName");

      this.sessionService.setE2EDeliveryConstructName($("#selectPAMClient option:selected").text());
      this.sessionService.setE2EUId(this.selectedPAMClientUId);

      if (this.selectedDCType == "DC" && this.selectedParentDCType == "DS") {
        this.sessionService.setDeliveryConstructName(this.selectedDCName);
        this.sessionService.setDeliveryConstructUId(this.selectedDeliveryConstructUId);
        this.sessionService.setWSUId(this.selectedDeliveryConstructUId);
        this.sessionService.setCMSUId(this.ParentE2EUID);
      }
      else if (this.selectedDCType == "DC" && this.selectedParentDCType != "DS") {
        this.sessionService.setDeliveryConstructName(this.selectedDCName);
        this.sessionService.setDeliveryConstructUId(this.selectedDeliveryConstructUId);
        this.sessionService.setWSUId(this.selectedDeliveryConstructUId);
        this.sessionService.setParentDeliveryConstructName(this.selectedParentDCName);
        this.sessionService.setCMSUId(this.selectedParentDeliveryConstructUId);
      }
      else {
        this.sessionService.setDeliveryConstructUId(this.selectedDeliveryConstructUId);
        this.sessionService.setCMSUId(this.ParentE2EUID);
        this.sessionService.setWSUId(this.selectedDeliveryConstructUId);
      }
    }
    var e2EUID = this.sessionService.getE2EUId();
    var cMSUID = this.sessionService.getCMSUId();
    var wSUID = this.sessionService.getWSUId();
    this.urlWSUID = wSUID;
    this.urlE2EUId = e2EUID;
    this.urlCMSUID = cMSUID;
    if (this.router.url.includes("/deepdive")) {

      if (this.envVar.instanceType == 'FDS') {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate(['deepdive'], { queryParams: { E2EUID: e2EUID, CMSUID: cMSUID, WSUID: wSUID } }));
      }
      else {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate(['deepdive'], { queryParams: { ClientUId: e2EUID, AssociatedDeliveryConstructUId: cMSUID, DeliveryConstructUId: wSUID } }));

      }
    }
    else {
      if (this.envVar.instanceType == 'FDS') {
        this.router.navigate(['deepdive'], { queryParams: { E2EUID: e2EUID, CMSUID: cMSUID, WSUID: wSUID } });
      }
      else {
        this.router.navigate(['deepdive'], { queryParams: { ClientUId: e2EUID, AssociatedDeliveryConstructUId: cMSUID, DeliveryConstructUId: wSUID } });
      }
    }
    var scopeSelectorElement = document.getElementById('scopeSelector') as HTMLElement;
    scopeSelectorElement.click();
  }
  LogOut() {
    localStorage.clear();
    sessionStorage.clear();
    if (this.envVar.instanceType == 'FDS') {
      this.msalService.logout();
    }
    else {
      this.iomservice.logOut();
    }
  }
  navigateToHome() {
    let userType = parseInt(this.sessionService.getSessionStorageItem("userType"));
    switch (userType) {
      case 1:
        if(sessionStorage.getItem("Instance") == "PAM")
        {
          let e2EUID = this.sessionService.getE2EUId();
          let cMSUID = this.sessionService.getCMSUId();
          let wSUID = this.sessionService.getWSUId();
          if (e2EUID != '' && e2EUID != undefined && e2EUID != null) {
              this.router.navigate(['deepdive'], { queryParams: { E2EUID: e2EUID, CMSUID: cMSUID, WSUID: wSUID } });
          }
        }
        else{
        this.router.navigate(["proposalsummary"]);
        }
        break;
      case 3:
        if(sessionStorage.getItem("Instance") == "PAM")
        {
          let e2EUID = this.sessionService.getE2EUId();
          let cMSUID = this.sessionService.getCMSUId();
          let wSUID = this.sessionService.getWSUId();
          if (e2EUID != '' && e2EUID != undefined && e2EUID != null) {
              this.router.navigate(['deepdive'], { queryParams: { E2EUID: e2EUID, CMSUID: cMSUID, WSUID: wSUID } });
          }
        }
        else{
        if (sessionStorage.getItem("redirecttoStandalone") == "standalone") {
          this.flagforStandalone = false;
          this.router.navigate(["proposalsummary"]);
        }
        else {
          let e2EUID = this.sessionService.getE2EUId();
          let cMSUID = this.sessionService.getCMSUId();
          let wSUID = this.sessionService.getWSUId();
          if (e2EUID != '' && e2EUID != undefined && e2EUID != null) {
            if (this.envVar.instanceType == 'FDS') {
              this.flagforStandalone = true;
              this.router.navigate(['deepdive'], { queryParams: { E2EUID: e2EUID, CMSUID: cMSUID, WSUID: wSUID } });
            }
            else {
              this.flagforStandalone = false;
              this.router.navigate(['deepdive'], { queryParams: { ClientUId: e2EUID, AssociatedDeliveryConstructUId: cMSUID, DeliveryConstructUId: wSUID } });
            }
          }
        }
      }
        break;
      case 4:
        let solutionId = this.sessionService.getSolutionId();
        this.router.navigate(['deepdive'], { queryParams: { SolutionId: solutionId } });
        break;
      default:
        break;
    }
  }

  getuserdetailbyversion(versionId) {
    var DyServiceVar;
    //if (this.envVar.instanceType == 'FDS')
    // DyServiceVar = this.iomservice.GetFlowDetailsbyVersionId(versionId, this.LoggedInUser);
    //else
    DyServiceVar = this.iomservice.GetPAMFlowDetailsbyVersionId(versionId, this.LoggedInUser);

    DyServiceVar.subscribe((data: UserDetails) => {
      if (data != null) { 
        this.userdetailsbyversionid = data;
        this.sessionService.setSessionStorageItem("userType", this.userdetailsbyversionid.UserType.toString());
        this.iomservice.isactivedeepdive = this.userdetailsbyversionid.ShowHide;
        //Standalone FLow
        if (this.userdetailsbyversionid.UserType == 1 && this.envVar.Env == "FDS_ManualUpload") {
          if (this.userdetailsbyversionid.ProjectId != undefined && this.userdetailsbyversionid.ProjectId != null && this.userdetailsbyversionid.ProjectId != 0) {
            sessionStorage.setItem("selectedProposalId", this.userdetailsbyversionid.ProjectId.toString());
            sessionStorage.setItem("defaultDeliveryConstructUId", this.userdetailsbyversionid.ProjectId.toString());
            this.messageService.loadHeader(this.userdetailsbyversionid.ProjectId);
            //this.GetProposalDataById(this.userdetailsbyversionid.ProjectId);
          }
        }
        else if (this.userdetailsbyversionid.UserType == 1 && this.envVar.Env == "SAAS_ManualUpload") {
          if (this.userdetailsbyversionid.E2EUID != undefined && this.userdetailsbyversionid.E2EUID != "") //FDS Flow
          {
            this.sessionService.setE2EUId(this.userdetailsbyversionid.E2EUID);
            this.GetProData('1');
            this.sessionService.setSessionStorageItem("userType", "1");
          }
        }
        //Fds
        else if (this.userdetailsbyversionid.UserType == 3) {
          if (this.userdetailsbyversionid.E2EUID != undefined && this.userdetailsbyversionid.E2EUID != "") //FDS Flow
          {
            this.sessionService.setE2EUId(this.userdetailsbyversionid.E2EUID);
            this.urlE2EUId = this.userdetailsbyversionid.E2EUID;
            if (this.userdetailsbyversionid.WSUID != undefined && this.userdetailsbyversionid.WSUID != "") {
              if (this.sessionService.getSessionStorageItem('setWSUIdCondition') == null && this.sessionService.getWSUId() == null)
              {
                if(this.envVar.Env == "FDS_ManualUpload")
                {
                this.sessionService.setSessionStorageItem("setWSUIdCondition", "False");
                this.sessionService.setWSUId(this.userdetailsbyversionid.WSUID);
                this.sessionService.setDeliveryConstructUId(this.userdetailsbyversionid.WSUID);
                this.urlWSUID = this.userdetailsbyversionid.WSUID;
                this.selectedDeliveryConstructUId = this.userdetailsbyversionid.WSUID;
                this.loadDeliveryConstructTree(this.userdetailsbyversionid.E2EUID, this.userdetailsbyversionid.WSUID);
                }
                else
                {                  
                  this.GetProData(null);
                }
              }
            }
            if (this.userdetailsbyversionid.CMSUID != undefined && this.userdetailsbyversionid.CMSUID != "") {
              this.sessionService.setCMSUId(this.userdetailsbyversionid.CMSUID);
              this.urlCMSUID = this.userdetailsbyversionid.CMSUID;
            }
            this.loadFDSScope = this.checkForScope();
            $('#standScope').hide();
            //need to handle
            if (sessionStorage.getItem("redirecttoStandalone") != "standalone") {
              this.flagforStandalone = false;
              this.getClientDeliveryConstructName("default");
            }
            else {
              this.iomservice.IsAuthorized = false;
              this.loadFDSScope = false;
              this.flagforStandalone = true;
            }

          }
        }
        //MySP
        else if (this.userdetailsbyversionid.UserType == 4) {
          if (this.userdetailsbyversionid.E2EID != undefined && this.userdetailsbyversionid.E2EID != "") {
            this.urlSolutionId = this.userdetailsbyversionid.E2EID.toString();
            this.sessionService.setSolutionId(this.urlSolutionId);
            this.getMySPClientDetails(this.urlSolutionId);
          }
        }
        else {
          //NOTHING TO DO
        }
      }
      else{
        this.router.navigate(['accessdenied']);
        this.spinner.hide();
      }
    })
  }
  userManul() {
    this.disclaimer = true;
    // this.sessionService.setSessionStorageItem("isactive","false");
    if (this.envVar.EnableDisclaimer == true)
    {
      userNotification.showUserNotificationModalPopup();
      // this.ngOnInit();
    }
    else
    {
      this.downloadUserManul();
    }
      this.spinner.hide();
  }
  
  downloadUserManul(): void { 
    this.spinner.show();
    if (this.disclaimer == true) {
      this.disclaimer = false;
        // this.blob = new Blob([data], { type: 'application/excel' });
        // var downloadURL = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = "./assets/Template/User_Manual.pdf";
        link.download = "IOM User Manual.pdf";
        link.click();
        this.spinner.hide();
    }
  }
}
